import React from 'react'
import Input from 'components/common/input/Input'
import PropTypes from 'prop-types'

function SearchInput({ handleChange, value, placeholder }) {
  return (
    <div className='search-input-otr filter-search-input'>
      <div className='search-otr-wrapper'>
        <Input
          className='filter-search-input__field'
          type='search'
          name='search'
          value={value}
          handleChange={(e) => {
            const targetValue = e.target.value || ''
            handleChange(targetValue)
          }}
          placeholder={placeholder}
        />
      </div>
    </div>
  )
}

SearchInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
}

SearchInput.defaultProps = {
  placeholder: '', // Provide a default value for the placeholder
}

export default SearchInput
